import {cx, XText} from "@cdx/common";
import {makeScrollable} from "@cdx/ds/utils/makeScrollable";
import uiClasses from "@cdx/common/xui/ui.css";
import {Box, Col} from "@cdx/ds";
import dsStyles from "@cdx/ds/css/index.css";
import {useTransition, animated} from "react-spring";
import ActivityFeed from "../activity-feed";

const ActivityFeedBar = ({isSmall, open, project, root}) => {
  const renderFn = useTransition(open, {
    from: {x: "100%", opacity: 0, presence: 0},
    initial: {x: "0%", opacity: 1, presence: 1},
    enter: {x: "0%", opacity: 1, presence: 1},
    leave: {x: "100%", opacity: 0.75, presence: 0},
    config: {tension: 2500, friction: 80},
  });

  return renderFn(({opacity, x, presence}, shown) =>
    shown ? (
      <>
        {!isSmall && (
          <animated.div
            style={{
              display: presence.to((v) => (v > 0.96 ? "block" : "none")),
              width: "22rem",
              flexShrink: 0,
            }}
          />
        )}
        <Box
          absolute
          top={0}
          bottom={0}
          right={0}
          className={cx(
            uiClasses.backgroundColor.gray800,
            uiClasses.boxShadow[2],
            makeScrollable()
          )}
          styleChild
        >
          <animated.aside style={{opacity, x, width: "22rem", zIndex: 5}}>
            <Col px={3} py={5} sp={3}>
              <XText color="gray400" preset="label" size={2} className={dsStyles.pl[6]}>
                Activity Feed
              </XText>
              <ActivityFeed arenaCtx={{}} model={project} isDark hideFilters root={root} />
            </Col>
          </animated.aside>
        </Box>
      </>
    ) : null
  );
};

export default ActivityFeedBar;
